<h2 mat-dialog-title>Add Note</h2>

<mat-dialog-content>
  <form [formGroup]="notaterForm">
    <div class="container py-3">
      <h5>Add Note</h5>

      <div class="mb-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>
            Note Text <span class="text-danger">*</span>
          </mat-label>
          <textarea
            matInput
            rows="7"
            formControlName="text"
            [ngClass]="{
              'is-invalid':
                notaterForm.get('text')?.invalid &&
                notaterForm.get('text')?.touched
            }"
          ></textarea>
          <mat-error
            *ngIf="
              notaterForm.get('text')?.invalid &&
              notaterForm.get('text')?.touched
            "
          >
            Note text is required.
          </mat-error>
        </mat-form-field>
      </div>

      <div class="row mb-3">

        <div class="col-md-8">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Reminder Date (optional)</mat-label>
            <input
              matInput
              [matDatepicker]="reminderPicker"
              formControlName="reminderDate"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="reminderPicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #reminderPicker></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="col-md-4">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Time</mat-label>
            <input matInput type="time" formControlName="reminderTime" />
          </mat-form-field>
        </div>
      </div>
    </div>

    <div align="end" class="p-3 border-top">
      <button
        mat-raised-button
        color="primary"
        [disabled]="notaterForm.invalid"
        (click)="saveNote()"
      >
        Save Note
      </button>
      <button mat-button mat-dialog-close>Close</button>

    </div>
  </form>
</mat-dialog-content>
